import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { useEditorStore } from '../../store/editorStore';

export function MobileEditorTopBar() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const projectName = useEditorStore((s) => s.project.name);

  return (
    <div
      className="flex items-center justify-between px-3 shrink-0 border-b border-[#2A2A2E]"
      style={{
        height: 48,
        paddingTop: 'env(safe-area-inset-top, 0px)',
        backgroundColor: '#0A0A0A',
      }}
    >
      {/* Close button */}
      <button
        onClick={() => navigate('/studio')}
        className="p-2 -ms-1 rounded-full hover:bg-white/10 transition-colors"
        aria-label={t('common.close', 'Close')}
      >
        <X size={20} />
      </button>

      {/* Project name */}
      <div className="flex-1 text-center">
        <span className="text-sm font-medium truncate max-w-[200px] inline-block">
          {projectName}
        </span>
      </div>

      {/* Spacer to balance close button */}
      <div className="w-9" />
    </div>
  );
}
